<tax-page-header titleText="registration.first.step.menu.name"></tax-page-header>

<div class="ui-kit-white-card">
  <tax-registration-top-menu></tax-registration-top-menu>

  <tax-registration-by-sms-form
    *ngIf="processForm?.formKey === bpRegistrationBySmsFormKeys.VerifyBySmsForm"
    (continueProcess)="goToSmsConfirmStep($event)"
  ></tax-registration-by-sms-form>

  <tax-registration-by-sms-confirm-phone
    *ngIf="processForm?.formKey === bpRegistrationBySmsFormKeys.SmsCodeForm"
    [userInfo]="userInfo"
    (confirmed)="showSuccessWindow = true"
    (goBack)="goToFirstStep()"
  ></tax-registration-by-sms-confirm-phone>
</div>

<tax-success-window
  *ngIf="showSuccessWindow"
  [action]="'success-sms'"
  (closed)="proceedRegistration()"
></tax-success-window>
